<template>
    <div class="editInfos-container">
        <div class="editInfos-head">
            <van-nav-bar title="编辑资料" left-arrow :border="false" @click-left="onClickLeft" />
            <div class="content-photo">
                <div @click="previewAvatar">
                    <img class="editInfo-Photo" :src="memberInfos.avatarLink || defaultPhoto" alt="">
                </div>
                <div>
                    <span>建议使用本人真实1:1尺寸照片</span>
                    <van-uploader accept='image/*' :before-read='onSelectAvatar'>
                        <img src="../assets/btn_upload head portrait@2x.png" alt="">
                    </van-uploader>
                </div>
            </div>
        </div>
        <div class="editInfos-content">
          <div class="form-tabs">
            <button type="button" class="tab-btn" :class="{ active: activeTab === 'basic' }" @click="activeTab = 'basic'">
                  基本资料
                </button>
                <button type="button" class="tab-btn" :class="{ active: activeTab === 'spouse' }" @click="activeTab = 'spouse'">
                  择偶要求
                </button>
              </div>
              <div v-show="activeTab === 'basic'">
              <van-cell title="编号">
                <template #default>
                    <span class="custom-title">{{ memberInfos.serialNumber }}</span>
                </template>
            </van-cell>
            <template>
                <van-cell title="姓名">
                    <template #default>
                        <span class="custom-title">{{ memberInfos.name }}</span>
                    </template>
                </van-cell>
            </template>
            <van-cell title="昵称" is-link class="editInfos-input" @click="handleInputForce('nickName')">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.nickName || '未设置' }}</span>
                </template>
            </van-cell>
            <van-cell title="性别">
                <template #default>
                    <span class="custom-title">{{ memberInfos.sex ? memberInfos.sex === 1 ? '男' : '女' : '' }}</span>
                </template>
            </van-cell>
            <!--  @click="currentDateShow = true" -->
            <van-cell title="出生年月">
                <template #default>
                    <span class="custom-title">{{ getFormatTime(memberInfos.birthday) }}</span>
                </template>
            </van-cell>
            <van-cell title="籍贯">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.hometown }}</span>
                </template>
            </van-cell>
            <!--  @click="educationPicker = true" -->
            <van-cell title="学历">
                <template #default>
                    <span class="custom-title"> {{ educationData[memberInfos.education - 1] }}</span>
                </template>
            </van-cell>
            <!--   @click="graduateSchoolForce" -->
            <van-cell title="毕业学校名称">
                <template #default>
                    <!-- <van-field
            v-model="memberInfos.graduateSchool"
            :colon='true'
            placeholder="请输入毕业学校名称"
            input-align="right"
            @blur='graduateSchoolOk'
            ref='graduateSchool'
          /> -->
                    <span class="custom-title"> {{ memberInfos.graduateSchool }}</span>
                </template>
            </van-cell>
            <van-cell title="民族" class="editInfos-input">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.nation }}</span>
                </template>
            </van-cell>
            <van-cell title="个人信仰" class="editInfos-input">
                <template #default>
                    <span class="custom-title"> {{ personalBeliefsData[memberInfos.personalBeliefs - 1] }}</span>
                </template>
            </van-cell>
            <van-cell title="跟进红娘">
                <!--  @click="showPickerMatchmaker = true" -->
                <template #default>
                    <span class="custom-title"> {{ memberInfos.matchmakerName }}</span>
                </template>
            </van-cell>
            <!-- <van-cell title="入会推荐人">
            <template #default>
              <span class="custom-title" > {{memberInfos.referrer}}</span>
            </template>
      </van-cell> -->
            <van-cell title="跟进情况" class="editInof-footer">
                <!-- @click="followUpStatusPicker = true" 用户编辑页暂时去掉编辑根据情况 -->
                <template #default>
                    <span class="custom-title">{{ [1, 2, 3, 4].includes(memberInfos.followUpStatus) ?
                        statusData[memberInfos.followUpStatus - 1] + ': ' + memberInfos.followUpDescription :
                        '暂无跟进情况'}}</span>
                </template>
            </van-cell>
            <van-cell title="身高">
                <template #default>
                    <span class="custom-title">{{ !memberInfos.height ? '' : memberInfos.height + 'CM' }}</span>
                </template>
            </van-cell>
            <van-cell title="体重" @click="handleInputForce('weight')" is-link>
                <template #default>
                    <span class="custom-title">{{ !memberInfos.weight ? '' : memberInfos.weight + 'KG' }}</span>
                </template>
            </van-cell>
            <van-cell title="我是这样的人" is-link class="editInfos-input" @click="goToTagSelector(1)">
                <template #default>
                    <span v-if="personalityTags.length > 0" class="custom-title">
                        <span v-for="(tag, index) in personalityTags" :key="index" class="tag-inline">
                            {{ tag.tagName }}
                        </span>
                    </span>
                    <span v-else class="custom-title" style="color: #969799;">点击添加我是这样的人</span>
                </template>
            </van-cell>
            <van-cell title="兴趣爱好描述" is-link class="editInfos-input" @click="$router.push({ path: '/checkInterests' })">
                <template #default>
                    <span class="custom-title" v-for="(item, index) in memberInfos.descriptionOfPersonalInterests"
                        :key="index">
                        <span>{{ checkboxData[item - 1] }}</span>
                        <!-- {{memberInfos.descriptionOfPersonalInterests}} -->
                    </span>
                </template>
            </van-cell>

            <van-cell title="公司名称" class="editInfos-input">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.companyName }}</span>
                </template>
            </van-cell>
            <van-cell title="所在部门" class="editInfos-input">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.department }}</span>
                </template>
            </van-cell>
            <van-cell title="岗位名称" class="editInfos-input">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.positionTitle }}</span>
                </template>
            </van-cell>
            <!-- <van-cell
                title="抖音号"
                class="editInfos-input"
                @click="handleInputForce('tikTok')"
                is-link
            >
                <template #default>
                    <span class="custom-title"> {{memberInfos.tikTok}}</span>
                </template>
            </van-cell> -->
            <van-cell title="婚姻状态">
                <template #default>
                    <span class="custom-title"> {{ maritalStatusData[memberInfos.maritalStatus - 1] }}</span>
                </template>
            </van-cell>
            <van-cell title="期望结婚时间" @click="showExpectedMarriageDatePicker" is-link>
                <template #default>
                    <span class="custom-title"> {{ formatExpectedMarriageDate(memberInfos.expectedMarriageDate) }}</span>
                </template>
            </van-cell>
            <van-cell title="家庭情况描述" class="editInfos-input" is-link
                @click="handleInputForce('personalFamilyDescription')">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.personalFamilyDescription }}</span>
                </template>
            </van-cell>
            <van-cell :title="housingSituationLabel" @click="showDesctiptPicker = true" is-link>
                <template #default>
                    <span class="custom-title"> {{ desctColumns[memberInfos.housingSituation - 1] }}</span>
                </template>
            </van-cell>
            <van-cell title="联系电话" class="editInfos-input" is-link @click="handleInputForce('contactNumber')">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.contactNumber }}</span>
                </template>
            </van-cell>
            <van-cell title="情感状态" is-link @click="goToEmotionalStatusEdit">
                <template #default>
                    <span class="custom-title"> {{ getEmotionalStatusText(memberInfos.emotionalStatus) }}</span>
                </template>
            </van-cell>
            <van-cell is-link class="editInfos-upload">
                <template #title>
                    <span class="custom-title">上传照片</span>
                    <span style="color:#999">345*500</span>
                </template>
                <template #default>
                    <van-uploader v-model="memberInfos.personalPhotos" accept='image/*' :before-read='beforeRead'
                        :before-delete="beforeDelete" :max-count='3' />
                </template>
            </van-cell>
            <!-- <template>
                <van-cell
                    title="是否公开照片"
                    is-link
                >
                    <template #default>
                        <van-switch
                            size='1.6rem'
                            v-model="memberInfos.showAvatar === 1 ? true : false"
                            @change='changeChecked'
                        />
                    </template>
                </van-cell>
            </template> -->
            <van-cell title="交友宣言" class="editInfos-input" is-link @click="openDatingDialog">
                <template #default>
                    <span class="custom-title"> {{ memberInfos.datingDeclaration || '未设置' }}</span>
                </template>
            </van-cell>
            </div>
            <div v-show="activeTab === 'spouse'">
              <div class="spouse-requirement-section">
                <van-cell title="我想找这样的人" is-link class="editInfos-input" @click="goToTagSelector(2)">
                <template #default>
                  <span v-if="spouseRequirementTags.length > 0" class="custom-title">
                    <span v-for="(tag, index) in spouseRequirementTags" :key="index" class="tag-inline">
                    {{ tag.tagName || tag }}
                  </span>
                  </span>
                      <span v-else class="custom-title" style="color: #969799;">点击添加</span>
                          </template>
                              </van-cell>
                                  <van-cell title="最早出生年份" is-link @click="spouseBirthYearMinShow = true">
                          <template #default>
                      <span class="custom-title">{{ spouseRequirement.spouseBirthYearMin || '请选择' }}</span>
                  </template>
                  </van-cell>
                <van-cell title="最晚出生年份" is-link @click="spouseBirthYearMaxShow = true">
<template #default>
                <span class="custom-title">{{ spouseRequirement.spouseBirthYearMax || '请选择' }}</span>
                </template>
                  </van-cell>
                        <van-cell title="身高（最小CM）" is-link @click="spouseHeightMinPickerShow = true">
                    <template #default>
                    <span class="custom-title">{{ spouseRequirement.spouseHeightMin ? spouseRequirement.spouseHeightMin + 'CM' : '请选择' }}</span>
                        </template>
                  </van-cell>
                <van-cell title="身高（最大CM）" is-link @click="spouseHeightMaxPickerShow = true">
<template #default>
                <span class="custom-title">{{ spouseRequirement.spouseHeightMax ? spouseRequirement.spouseHeightMax + 'CM' : '请选择' }}</span>
                </template>
                  </van-cell>
                    <van-cell title="学历" is-link @click="spouseEducationPickerShow = true">
                    <template #default>
                  <span class="custom-title">{{ spouseEducationText }}</span>
                  </template>
                    </van-cell>
                  </div>
        </div>
        <p class="spouse-refresh-tip">AI推荐会员每月15日刷新，<br>修改择偶要求后请耐心等待结果更新噢~</p>
        </div>
        <van-popup v-model:show="currentDateShow" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker v-model="currentDate" type="year-month" title="选择出生年月" :min-date="minDate"
                :max-date="maxDate" @confirm='confimDate' @cancel='currentDateShow = false' />
        </van-popup>
        <van-popup v-model:show="areaCheck" position="bottom" :style="{ height: '50%' }">
            <van-area v-model="code" title="请选择所在地区" :area-list="areaData" :columns-num="2" @cancel="areaCheck = false"
                @confirm="onFinish" />
        </van-popup>
        <van-popup v-model:show="showHighPicker" round position="bottom">
            <van-picker :columns="highColumns" @cancel="showHighPicker = false" @confirm="onHighConfirm"
                :show-toolbar='true' />
        </van-popup>
        <van-popup v-model:show="showMaritalStatusPicker" round position="bottom">
            <van-picker :columns="maritalStatusData" @cancel="showMaritalStatusPicker = false"
                @confirm="onMaritalStatusConfirm" :show-toolbar='true' />
        </van-popup>
        <van-popup v-model:show="showDesctiptPicker" round position="bottom">
            <van-picker :columns="desctColumns" @cancel="showDesctiptPicker = false" @confirm="onDesctConfirm"
                :show-toolbar='true' />
        </van-popup>
        <van-popup v-model:show="expectedMarriageDateShow" round position="bottom">
            <van-datetime-picker v-model="expectedMarriageDatePicker" type="date" title="选择日期"
                :min-date="expectedMarriageMinDate" :max-date="expectedMarriageMaxDate"
                @confirm='confirmExpectedMarriageDate' @cancel='expectedMarriageDateShow = false' />
        </van-popup>
        <!-- <van-popup v-model:show="showPickerMatchmaker" round position="bottom">
       <van-cascader
          v-model="cascaderValue"
          title="请选择红娘"
          :options="matchPartition"
          @change="onChangeMatchmaker"
          @close="showPickerMatchmaker = false"
          @finish="onMatchmakerConfirm"
        />
    </van-popup> -->
        <van-popup v-model:show="educationPicker" round position="bottom">
            <van-picker :columns="educationData" @cancel="educationPicker = false" @confirm="educationConfirm"
                :show-toolbar='true' />
        </van-popup>
        <!-- <van-popup v-model:show="followUpStatusPicker" round position="bottom">
      <van-picker
        :columns="followUpStatusData"
        @cancel="followUpStatusPicker = false"
        @confirm="followUpStatusConfirm"
        :show-toolbar='true'
      />
    </van-popup> -->

        <van-popup v-model:show="spouseBirthYearMinShow" round position="bottom">
            <van-picker title="选择最早出生年份" :columns="spouseBirthYearColumns" :default-index="spouseBirthYearMinIndex" @cancel="spouseBirthYearMinShow = false"
                @confirm="confirmSpouseBirthYearMin" :show-toolbar="true" />
        </van-popup>
        <van-popup v-model:show="spouseBirthYearMaxShow" round position="bottom">
            <van-picker title="选择最晚出生年份" :columns="spouseBirthYearColumns" :default-index="spouseBirthYearMaxIndex" @cancel="spouseBirthYearMaxShow = false"
                @confirm="confirmSpouseBirthYearMax" :show-toolbar="true" />
        </van-popup>
        <van-popup v-model:show="spouseEducationPickerShow" round position="bottom">
            <van-picker title="选择学历" :columns="spouseEducationData" :default-index="spouseEducationIndex" @cancel="spouseEducationPickerShow = false"
                @confirm="confirmSpouseEducation" :show-toolbar="true" />
        </van-popup>
        <van-popup v-model:show="spouseHeightMinPickerShow" round position="bottom">
            <van-picker title="选择最小身高" :columns="highColumns" :default-index="spouseHeightMinIndex" @cancel="spouseHeightMinPickerShow = false"
                @confirm="confirmSpouseHeightMin" :show-toolbar="true" />
        </van-popup>
        <van-popup v-model:show="spouseHeightMaxPickerShow" round position="bottom">
            <van-picker title="选择最大身高" :columns="highColumns" :default-index="spouseHeightMaxIndex" @cancel="spouseHeightMaxPickerShow = false"
                @confirm="confirmSpouseHeightMax" :show-toolbar="true" />
        </van-popup>
        <avatar-cropper :visible.sync="cropperVisible" :img-src="rawImgSrc" @confirm="onCropConfirm"
            @cancel="onCropCancel" :fixedNumber="fixedNumber" />
            <van-popup v-model="datingDialogShow" round closeable close-icon-position="top-left"
                position="bottom" :style="{ width: '100%', boxSizing: 'border-box', overflow: 'hidden' }" class="dating-popup">
                <div class="dating-dialog">
                    <div class="dating-dialog__header">交友宣言</div>
            <div class="dating-dialog__sub">一句话介绍自己，让TA更懂你（最多100字）</div>
                        <div class="dating-dialog__textarea-wrap">
                    <textarea v-model="datingDeclarationInput" class="dating-dialog__textarea"
                        placeholder="例如：希望能遇到志同道合的人" maxlength="100" rows="4"></textarea>
                    <span class="dating-dialog__count">{{ (datingDeclarationInput || '').length }}/100</span>
                </div>
            <div class="dating-dialog__footer">
            <van-button block round type="primary" @click="saveDatingDeclaration">保存</van-button>
                    </div>
                </div>
            </van-popup>
    </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import { Toast, ImagePreview } from "vant";
import { mapGetters } from "vuex";
import { updateUserInfo, upLoadImages, getMemberTags } from "../api/user";
import defaultPhoto from "../assets/defaultPhoto.png";
import AvatarCropper from "../components/AvatarCropper.vue";
export default {
    components: { AvatarCropper },
    data() {
        return {
            housingSituationLabel: "宁德住房情况",
            ChineseCOMPANYNAME: process.env.ChineseCOMPANYNAME,
            COMPANYNAME: process.env.COMPANYNAME,
            TEL: process.env.TEL,
            fixedNumber: [100,69], // 截图框比例
            memberInfos: {
                serialNumber: "",
                name: "",
                nickName: "",
                sex: "",
                avatarLink: "",
                birthday: "",
                tikTok: "", // v-model的抖音号
                hometown: "",
                height: "",
                weight: "",
                personalBeliefs: "",
                isAtl: 1,
                graduateSchool: "",
                education: "",
                referrer: "",
                matchmakerName: "",
                descriptionOfSpouseSelectionRequirements: "", // v-model的择偶意向
                personalCharacterDescription: "", // v-model的个人概述
                followUpStatus: "",
                personalFamilyDescription: "",
                personalPhotos: [], // 上传的图片
                showAvatar: true,
                emotionalStatus: null,
                expectedMarriageDate: ""
              },
              datingDialogShow: false,
            datingDeclarationInput: "",
            // 择偶要求页签
            activeTab: "basic",
            spouseRequirement: {
                spouseBirthYearMin: "",
                spouseBirthYearMax: "",
                spouseSex: "",
                spouseHeightMin: "",
                spouseHeightMax: "",
                spouseEducation: ""
            },
            spouseBirthYearMinShow: false,
            spouseBirthYearMaxShow: false,
            spouseSexPickerShow: false,
            spouseEducationPickerShow: false,
            spouseHeightMinPickerShow: false,
            spouseHeightMaxPickerShow: false,
            spouseBirthYearColumns: Array.from(
                { length: 2020 - 1970 + 1 },
                (_, index) => `${2020 - index}`
            ),
            cascaderValue: "",
            referrerValue: "",
            maxDate: new Date(),
            minDate: new Date(0),
            currentDate: "", // v-model的出生年月
            expectedMarriageDatePicker: new Date(),
            expectedMarriageMinDate: new Date(),
            expectedMarriageMaxDate: new Date(new Date().getFullYear() + 10, 11, 31),
            // birthday: '请选择出生年月',
            code: "", // v-model的地区
            educationData: ["大专", "本科", "硕士", "博士", "高中及以下"], // 学历picker数组
            spouseEducationData: ["不限", "大专及以上", "本科及以上", "硕士及以上", "博士及以上"], // 择偶学历picker数组(0-不限/1-大专及以上/...)
            desctColumns: ["自己有住房", "已购房", "计划购房", "无计划"],
            maritalStatusData: ["未婚", "离异/无子女", "离异有子女", "其他"],
            followUpStatusData: [
                "微信聊天中",
                "已见面互有好感恋爱中",
                "已见家长",
                "已订婚领取结婚证",
                "其它情况"
            ],
            statusData: ["启动", "过程", "结果", "取消跟进"],
            personalBeliefsData: [
                "基督教",
                "天主教",
                "佛教",
                "伊斯兰教",
                "无",
                "其它"
            ],
            checkboxData: [
                "球类运动（篮球、兵乓球、羽毛球等）",
                "体育运动（跑步、跳绳、健身等）",
                "户外活动（旅游、登山）",
                "文艺类（唱歌、跳舞、乐器）",
                "娱乐类（逛街、看电影、看书）",
                "冒险类（潜水，攀岩）",
                "智力类（拼图、拆装）",
                "游戏类（桌游、网游）",
                "休闲类（园艺、写生、摄影）",
                "美食类（火锅、烧烤等）",
                "烹饪类（中餐、西餐、糕点）",
                "其他"
            ],
            highColumns: [], //身高picker数组
            personalityTags: [],
            spouseRequirementTags: [],
            emotionalStatusOptions: {
                1: '单身ing',
                // 2: '暗恋中',
                // 3: '暧昧中',
                4: '恋爱ing',
                // 5: '订婚',
                6: '已结婚',
                // 99: '其他'
            },
            matchPartition: [
                { text: "W区", value: 1 },
                { text: "E区", value: 2 },
                { text: "M区", value: 3 },
                { text: "R区", value: 4 }
            ],
            areaData: areaList,
            // 气泡显隐控制
            currentDateShow: false,
            tiktokShow: false,
            areaCheck: false,
            showHighPicker: false,
            showDesctiptPicker: false,
            educationPicker: false,
            showMaritalStatusPicker: false,
            expectedMarriageDateShow: false,
            // showPickerMatchmaker: false,
            // followUpStatusPicker: false,
            cropperVisible: false,
            rawImgSrc: '',
            cropTarget: ''
        };
    },
    methods: {
        getEmotionalStatusText(status) {
            return this.emotionalStatusOptions[status] || '未设置';
        },
        formatExpectedMarriageDate(value) {
            if (!value) {
                return '未设置';
            }
            const date = new Date(value);
            if (isNaN(date.getTime())) {
                return value;
            }
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return date.getFullYear() + '-' + month + '-' + day;
        },
        goToEmotionalStatusEdit() {
            this.$router.push({ path: '/emotionalStatusEdit' });
        },
        goToTagSelector(tagType) {
            this.$router.push({
                path: '/tagSelector',
                query: { tagType: tagType, memberId: this.baseInfo.id }
            });
        },
        // 预览头像大图
        previewAvatar() {
            if (this.memberInfos.avatarLink) {
                ImagePreview({
                    images: [this.memberInfos.avatarLink],
                    closeable: true,
                    closeIconPosition: 'top-right',
                });
            }
        },
        async loadMemberTags() {
            if (this.baseInfo && this.baseInfo.id) {
                try {
                    const res = await getMemberTags(this.baseInfo.id);
                    if (res.code === 20000 && res.data) {
                        this.personalityTags = res.data.personalityTags || [];
                        this.spouseRequirementTags = res.data.spouseRequirementTags || [];
                    }
                } catch (error) {
                    console.error('加载会员标签失败', error);
                }
            }
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        // 确认选择时间
        confimDate() {
            this.currentDateShow = false;
            let month = new Date(this.currentDate).getMonth() + 1;
            if (month < 10) {
                month = "0" + month;
            }
            let birthday =
                new Date(this.currentDate).getFullYear() + "." + month;
            this.update("birthday", birthday, () => {
                this.memberInfos.birthday = birthday;
            });
        },
        showExpectedMarriageDatePicker() {
            if (this.memberInfos.expectedMarriageDate) {
                const currentValue = new Date(this.memberInfos.expectedMarriageDate);
                if (!isNaN(currentValue.getTime())) {
                    this.expectedMarriageDatePicker = currentValue;
                }
            }
            this.expectedMarriageDateShow = true;
        },
        confirmExpectedMarriageDate() {
            this.expectedMarriageDateShow = false;
            const date = new Date(this.expectedMarriageDatePicker);
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            const expectedMarriageDate = `${year}-${month}-${day}`;
            this.update('expectedMarriageDate', expectedMarriageDate, () => {
                this.memberInfos.expectedMarriageDate = expectedMarriageDate;
            });
        },
        // 根据选择的值跳转到编辑页,是ATL内部员工时,部分字段不可编辑
        handleInputForce(value, isEdit = false) {
            if (!isEdit) {
                this.$router.push({ path: `/editFiled/${value}` });
            }
        },
        // 打开交友宣言弹窗
        openDatingDialog() {
            this.datingDeclarationInput = this.memberInfos.datingDeclaration || "";
            this.datingDialogShow = true;
        },
        // 保存交友宣言（直接更新到数据库）
        saveDatingDeclaration() {
            const value = this.datingDeclarationInput.trim();
            this.memberInfos.datingDeclaration = value;
                this.datingDialogShow = false;
            this.update("datingDeclaration", value, () => {
                    Toast({ message: "保存成功" });
                });
            },
        // 更新统一方法, key newKey value,name 是此次更新的值,call回调方法,更新请求完更新vuex数据
        update(key, value, callback, newKey = null, name = null) {
            let data = JSON.parse(JSON.stringify(this.baseInfo));
            data[key] = value;
            if (newKey) {
                data[newKey] = name;
            }
            updateUserInfo(data).then(res => {
                if (res.code === 20000) {
                    this.$store.dispatch("UpdateBasicInfo", res.data);
                    callback && callback();
                }
            });
        },
        // 选择完籍贯确定触发
        onFinish(value) {
            this.areaCheck = false;
            let hometown = value.map(option => option.name).join("/");
            this.update("hometown", hometown, () => {
                this.memberInfos.hometown = hometown;
            });
        },
        // 选择完身高确定触发
        onHighConfirm(value) {
            this.showHighPicker = false;
            this.update("height", value, () => {
                this.memberInfos.height = value;
            });
        },
        // 编辑宁德住房情况
        onDesctConfirm(value, index) {
            this.showDesctiptPicker = false;
            this.update("housingSituation", index + 1, () => {
                this.memberInfos.housingSituation = index + 1;
            });
        },
        // 修改婚姻情况
        onMaritalStatusConfirm(value, index) {
            this.showMaritalStatusPicker = false;
            this.update("maritalStatus", index + 1, () => {
                this.memberInfos.maritalStatus = index + 1;
            });
        },
        // 选择完学历确定触发
        educationConfirm(value, index) {
            this.educationPicker = false;
            this.update("education", index + 1, () => {
                this.memberInfos.education = index + 1;
            });
        },
        openCropper(file, target) {
            if (target === 'personalPhoto' && this.memberInfos.personalPhotos.length >= 3) {
                Toast({ message: '最多上传3张照片' });
                return false;
            }
            this.cropTarget = target;
            const reader = new FileReader();
            reader.onload = e => {
                this.rawImgSrc = e.target.result;
                this.cropperVisible = true;
            };
            reader.readAsDataURL(file);
            return false;
        },
        resetCropperState() {
            this.cropperVisible = false;
            this.rawImgSrc = '';
            this.cropTarget = '';
        },
        // 上传照片,选择后先裁剪再上传
        beforeRead(file) {
            this.fixedNumber= [100,69];
            return this.openCropper(file, 'personalPhoto');
        },
        // 删除照片,获取到当前的index,对应删除
        beforeDelete(file, detail) {
            let data = JSON.parse(JSON.stringify(this.baseInfo));
            data.personalPhotos.splice(detail.index, 1);
            updateUserInfo(data).then(item => {
                if (item.code === 20000) {
                    this.$store.dispatch("UpdateBasicInfo", item.data);
                    this.memberInfos.personalPhotos = data.personalPhotos;
                    Promise.resolve();
                } else {
                    Promise.reject();
                }
            });
        },
        // 上传用户照片，替换掉原有的。
        onSelectAvatar(file) {
            this.fixedNumber=[1,1];
            return this.openCropper(file, 'avatar');
        },
        async uploadCroppedImage(blob, fileName) {
            const formData = new FormData();
            formData.append('formFile', blob, fileName);
            return upLoadImages(formData);
        },
        onCropCancel() {
            this.resetCropperState();
        },
        async onCropConfirm(blob) {
            const cropTarget = this.cropTarget;
            try {
                const res = await this.uploadCroppedImage(blob, cropTarget === 'avatar' ? 'avatar.jpg' : 'personal-photo.jpg');
                if (res.code !== 20000) {
                    Toast({ message: '上传失败' });
                    return;
                }
                let data = JSON.parse(JSON.stringify(this.baseInfo));
                if (cropTarget === 'avatar') {
                    data.avatarLink = res.data;
                } else if (cropTarget === 'personalPhoto') {
                    data.personalPhotos = this.baseInfo.personalPhotos
                        ? [...this.baseInfo.personalPhotos, { url: res.data }]
                        : [{ url: res.data }];
                }
                const item = await updateUserInfo(data);
                if (item.code === 20000) {
                    this.$store.dispatch('UpdateBasicInfo', item.data);
                    this.memberInfos.personalPhotos = data.personalPhotos;
                    if (cropTarget === 'avatar') {
                        this.memberInfos.avatarLink = res.data;
                    }
                    Toast({ message: '上传成功' });
                } else {
                    Toast({ message: '上传失败' });
                }
            } catch (e) {
                Toast({ message: '上传失败' });
            } finally {
                this.resetCropperState();
            }
        },

        // 切换开关时调用接口
        changeChecked(value) {
            let num = value ? 1 : 2;
            this.update("showAvatar", num, () => {
                this.memberInfos.showAvatar = num;
            });
        },
        // ===== 择偶要求页签方法 =====
        confirmSpouseBirthYearMin(value) {
            if (this.spouseRequirement.spouseBirthYearMax && this.spouseRequirement.spouseBirthYearMax < value) {
                Toast({ message: "不能大于最大年份" });
                return;
            }
            this.spouseBirthYearMinShow = false;
            this.spouseRequirement.spouseBirthYearMin = value;
            this.saveSpouseRequirement();
        },
        confirmSpouseBirthYearMax(value) {
            if (this.spouseRequirement.spouseBirthYearMin && this.spouseRequirement.spouseBirthYearMin > value) {
                Toast({ message: "不能小于最小年份" });
                return;
            }
            this.spouseBirthYearMaxShow = false;
            this.spouseRequirement.spouseBirthYearMax = value;
            this.saveSpouseRequirement();
        },
        confirmSpouseEducation(value, index) {
            this.spouseEducationPickerShow = false;
            this.spouseRequirement.spouseEducation = String(index);
            this.saveSpouseRequirement();
        },
        confirmSpouseHeightMin(value) {
            if (this.spouseRequirement.spouseHeightMax && this.spouseRequirement.spouseHeightMax < value) {
                Toast({ message: "不能大于最大身高" });
                return;
            }
            this.spouseHeightMinPickerShow = false;
            this.spouseRequirement.spouseHeightMin = value;
            this.saveSpouseRequirement();
        },
        confirmSpouseHeightMax(value) {
            if (this.spouseRequirement.spouseHeightMin && this.spouseRequirement.spouseHeightMin > value) {
                Toast({ message: "不能小于最小身高" });
                return;
            }
            this.spouseHeightMaxPickerShow = false;
            this.spouseRequirement.spouseHeightMax = value;
            this.saveSpouseRequirement();
        },
        saveSpouseRequirement() {
            let data = JSON.parse(JSON.stringify(this.baseInfo));
            data.spouseBirthYearMin = this.spouseRequirement.spouseBirthYearMin;
            data.spouseBirthYearMax = this.spouseRequirement.spouseBirthYearMax;
            data.spouseSex = this.spouseRequirement.spouseSex;
            data.spouseHeightMin = this.spouseRequirement.spouseHeightMin;
            data.spouseHeightMax = this.spouseRequirement.spouseHeightMax;
            data.spouseEducation = this.spouseRequirement.spouseEducation;
            data.datingDeclaration = this.memberInfos.datingDeclaration || "";
                updateUserInfo(data).then(res => {
                    if (res.code === 20000) {
                    this.$store.dispatch("UpdateBasicInfo", res.data);
                Toast({ message: "保存成功" });
                    } else {
                Toast({ message: res.info || "保存失败" });
            }
                }).catch(() => {
            Toast({ message: "保存失败" });
        });
        }
    },
    computed: {
        ...mapGetters(["baseInfo"]),
        isAtl2() {
            return this.COMPANYNAME == "ATL";
        },
    spouseEducationText() {
            const map = { '0': '不限', '1': '大专及以上', '2': '本科及以上', '3': '硕士及以上', '4': '博士及以上' };
            return map[this.spouseRequirement.spouseEducation] || '请选择';
        },
    // 择偶要求 picker 默认选中索引
    spouseBirthYearMinIndex() {
    const v = this.spouseRequirement.spouseBirthYearMin;
        if (!v) return 0;
        return Math.max(0, 2020 - Number(v));
        },
    spouseBirthYearMaxIndex() {
    const v = this.spouseRequirement.spouseBirthYearMax;
        if (!v) return 0;
        return Math.max(0, 2020 - Number(v));
        },
    spouseEducationIndex() {
    const v = this.spouseRequirement.spouseEducation;
        if (v === null || v === undefined || v === "") return 0;
        return Math.max(0, Number(v));
        },
    spouseHeightMinIndex() {
    const v = this.spouseRequirement.spouseHeightMin;
        if (!v) return 0;
        return Math.max(0, Number(v) - 140);
        },
    spouseHeightMaxIndex() {
    const v = this.spouseRequirement.spouseHeightMax;
        if (!v) return 0;
        return Math.max(0, Number(v) - 140);
        }
    },
    created() {
        if (this.$route.query.tab) {
            this.activeTab = this.$route.query.tab;
        }
              if (!this.isAtl2) {
                  this.housingSituationLabel = "住房情况";
              }
        // 处理身高数组
        const newData = [];
        for (let index = 140; index < 226; index++) {
            newData.push(index);
        }
        this.highColumns = [].concat(newData);
        let data = JSON.parse(JSON.stringify(this.baseInfo));
        data.personalPhotos = data.personalPhotos || [];
        // 把兴趣爱好描述转成数组
        if (data.descriptionOfPersonalInterests) {
            data.descriptionOfPersonalInterests = data.descriptionOfPersonalInterests.split(
                ","
            );
        }
        this.memberInfos = data;
        // 初始化择偶要求字段
        this.spouseRequirement.spouseBirthYearMin = data.spouseBirthYearMin || "";
        this.spouseRequirement.spouseBirthYearMax = data.spouseBirthYearMax || "";
        // 择偶性别默认为异性：男(1)→女(2)，女(2)→男(1)
        var memberSex = data.sex ? Number(data.sex) : 1;
        this.spouseRequirement.spouseSex = data.spouseSex ? String(data.spouseSex) : String(memberSex === 1 ? 2 : 1);
        this.spouseRequirement.spouseHeightMin = data.spouseHeightMin || "";
        this.spouseRequirement.spouseHeightMax = data.spouseHeightMax || "";
        this.spouseRequirement.spouseEducation = data.spouseEducation ? String(data.spouseEducation) : "";
        this.loadMemberTags();
    },
    activated() {
        this.loadMemberTags();
            },
                watch: {
            baseInfo: {
            handler(newVal) {
        this.loadMemberTags();
        // 同步基本资料变更到 memberInfos（editFiled 保存后刷新）
        if (newVal) {
          this.memberInfos = JSON.parse(JSON.stringify(newVal));
          this.memberInfos.personalPhotos = this.memberInfos.personalPhotos || [];
          if (this.memberInfos.descriptionOfPersonalInterests && typeof this.memberInfos.descriptionOfPersonalInterests === "string") {
            this.memberInfos.descriptionOfPersonalInterests = this.memberInfos.descriptionOfPersonalInterests.split(",");
          }
        }
    },
            deep: true
        }
    }
};
</script>
<style lang="less" src='../style/editInfos.less' />



// WEBPACK FOOTER //
// src/views/editInfos.vue